module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-asa_line.ef9fe1c3.png";